import { useContext } from "react";
import { AppNotificationContext } from "./AppNotificationContext";
import { AppNotificationState } from "./AppNotificationContextTypes";

export function useAppNotificationContext() {
    const context = useContext<[AppNotificationState, (newState: AppNotificationState) => void] | undefined>(AppNotificationContext);
    if (!context) {
        throw new Error("useAppNotificationContext must be used within an AppNotificationContextProvider");
    }
    return context;
}
